import React, { useState, forwardRef, useImperativeHandle } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Card,
  CardContent,
  Grid,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";

const ContactSearch = forwardRef(
  ({ selectedFilters, setSelectedFilters }, ref) => {
    const [matchTypeOptions] = useState([
      { label: "Begins With", value: "startsWith" },
      { label: "Contains", value: "contains" },
      { label: "Equals", value: "exactMatch" },
    ]);

    const handleChange = (filterName, newValue, filterType) => {
      if (filterName === "selectedEmail") {
        setSelectedFilters((prevFilters) => ({
          ...prevFilters,
          [filterName]: {
            value: newValue,
            label: newValue,
            filterType: filterType || "",
          },
        }));
      } else if (filterName === "selectedEmailMatchType") {
        const selectedOption = matchTypeOptions.find(opt => opt.label === newValue);
        if (selectedOption) {
          setSelectedFilters((prevFilters) => ({
            ...prevFilters,
            selectedEmail: {
              value: prevFilters.selectedEmail?.value || "",
              label: prevFilters.selectedEmail?.value || "",
              filterType: selectedOption.value,
            },
          }));
        }
      } else {
        setSelectedFilters((prevFilters) => ({
          ...prevFilters,
          [filterName]: newValue,
        }));
      }
    };

    useImperativeHandle(ref, () => ({
      handleRefreshFilter() {
        // Reset is handled by parent
      },
    }));

    return (
      <div>
        <Card elevation={3} className="m-2 sm:m-4">
          <CardContent>
            <Typography variant="h6" className="mb-3 pt-3 pb-3">
              Contact Search
            </Typography>
            <Grid container spacing={2}>
              {/* First Row: Match Type + Search for Email */}
              <Grid item xs={6} md={6}>
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    options={matchTypeOptions.map(opt => opt.label)}
                    value={matchTypeOptions.find(opt => opt.value === selectedFilters.selectedEmail?.filterType)?.label || null}
                    onChange={(_, newValue) =>
                      handleChange("selectedEmailMatchType", newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Begin with Email"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} md={6}>
                <FormControl variant="outlined" fullWidth>
                  <TextField
                    label="Search for Email"
                    fullWidth
                    variant="outlined"
                    value={selectedFilters.selectedEmail?.value || ""}
                    onChange={(e) =>
                      handleChange(
                        "selectedEmail",
                        e.target.value,
                        selectedFilters.selectedEmail?.filterType
                      )
                    }
                  />
                </FormControl>
              </Grid>

              {/* Second Row */}
              <Grid item xs={12}>
                <FormControl variant="outlined" fullWidth>
                  <TextField
                    label="Enter Phone Number"
                    fullWidth
                    variant="outlined"
                    value={selectedFilters.selectedPhoneNumber || ""}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Extract only digits for search
                      const digitsOnly = input.replace(/\D/g, '');
                      // Only allow up to 10 digits
                      if (digitsOnly.length <= 10) {
                        handleChange("selectedPhoneNumber", digitsOnly);
                      }
                    }}
                    placeholder="Enter 10-digit phone number"
                    inputProps={{ maxLength: 10 }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
);

export default ContactSearch;
